import { render, staticRenderFns } from "./ContentProductInformation.vue?vue&type=template&id=af9dd6d2&"
import script from "./ContentProductInformation.vue?vue&type=script&lang=js&"
export * from "./ContentProductInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports